/*
    Substring Matcher
 */
export default function substringMatcher(searchArray) {
    return function findMatches(query, callback) {
        // an array that will be populated with substring matches
        const matches = [];

        // regex used to determine if a string contains the substring `q`
        const substrRegex = new RegExp(query, 'i');

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        searchArray.forEach((item) => {
            const key = item.key;

            if (substrRegex.test(key)) {
                // Output the final string to include the country
                if (item.hasOwnProperty('country') && item.country !== '') {
                    matches.push(`${key}, ${item.country}`);
                } else {
                    matches.push(key);
                }
            }
        });

        callback(matches);
    };
}



// WEBPACK FOOTER //
// ./client/js/utilities/substring-matcher.js